/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const NineSquareIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={22}
    height={22}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="NineSquareIcon">
    <path
      d="M14.583 3.333v3.75h3.75v-3.75h-3.75Zm2.813 2.813H15.52V4.27h1.875v1.875Zm-2.813 2.812v3.75h3.75v-3.75h-3.75Zm2.813 2.813H15.52V9.896h1.875v1.875ZM8.958 3.333v3.75h3.75v-3.75h-3.75Zm2.813 2.813H9.896V4.27h1.875v1.875ZM8.958 8.958v3.75h3.75v-3.75h-3.75Zm2.813 2.813H9.896V9.896h1.875v1.875Zm2.812 2.812v3.75h3.75v-3.75h-3.75Zm2.813 2.813H15.52V15.52h1.875v1.875Zm-8.438-2.813v3.75h3.75v-3.75h-3.75Zm2.813 2.813H9.896V15.52h1.875v1.875ZM3.333 3.333v3.75h3.75v-3.75h-3.75Zm2.813 2.813H4.27V4.27h1.875v1.875ZM3.333 8.958v3.75h3.75v-3.75h-3.75Zm2.813 2.813H4.27V9.896h1.875v1.875Zm-2.813 2.812v3.75h3.75v-3.75h-3.75Zm2.813 2.813H4.27V15.52h1.875v1.875Z"
      fill="currentColor"
    />
  </svg>
);

export const LeanNineSquareIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={10}
    height={10}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="LeanNineSquareIcon">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0H1.28013V2.17997H0V0Z"
      fill="var(--secondaryText)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.90649 0H4.18662V2.17997H2.90649V0Z"
      fill="var(--secondaryText)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.81311 0H7.09324V2.17997H5.81311V0Z"
      fill="var(--secondaryText)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.71985 0H9.99998V2.17997H8.71985V0Z"
      fill="var(--secondaryText)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 3.63379H1.28013V5.81376H0V3.63379Z"
      fill="var(--secondaryText)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.90649 3.63379H4.18662V5.81376H2.90649V3.63379Z"
      fill="var(--secondaryText)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.81311 3.63379H7.09324V5.81376H5.81311V3.63379Z"
      fill="var(--secondaryText)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.71985 3.63379H9.99998V5.81376H8.71985V3.63379Z"
      fill="var(--secondaryText)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 7.2666H1.28013V9.44658H0V7.2666Z"
      fill="var(--secondaryText)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.90649 7.2666H4.18662V9.44658H2.90649V7.2666Z"
      fill="var(--secondaryText)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.81311 7.2666H7.09324V9.44658H5.81311V7.2666Z"
      fill="var(--secondaryText)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.71985 7.2666H9.99998V9.44658H8.71985V7.2666Z"
      fill="var(--secondaryText)"
    />
  </svg>
);

export default NineSquareIcon;
